import { useEffect, useState } from 'react';

import { Modal } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

import { ScrollModalProps } from './ScrollModalFooter';
export interface ScrollModalHeaderProps extends ScrollModalProps {
  className?: string;
}

const ScrollModalHeader: React.FC<ScrollModalHeaderProps> = ({
  scrollRef,
  children,
  className,
  ...props
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const updateScrollStatus = () => {
      const scrollTop = scrollRef.current?.scrollTop;
      if (scrollTop !== 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    scrollRef.current?.addEventListener('scroll', updateScrollStatus);

    return () => window.removeEventListener('scroll', updateScrollStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollRef.current]);

  return (
    <Modal.Title
      className={cn(
        'z-5!',
        {
          'shadow-[0_8px_16px_-8px_rgba(0,0,0,0.16)]!': isScrolled,
        },
        className,
      )}
      {...props}
    >
      {children}
    </Modal.Title>
  );
};

export default ScrollModalHeader;
